// AUTHENTICATION
export const AUTH_START_SAGA = "AUTH_START_SAGA";
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

// PRODUCTS
export const GET_PRODUCTS_SAGA = "GET_PRODUCTS_SAGA";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAIL = "GET_PRODUCTS_FAIL";

export const UPDATE_PRODUCT_SAGA = "UPDATE_PRODUCT_SAGA";
export const UPDATE_PRODUCTS_SUCCESS = "UPDATE_PRODUCTS_SUCCESS";
export const UPDATE_PRODUCTS_FAIL = "UPDATE_PRODUCTS_FAIL";

export const DELETE_PRODUCT_SAGA = "DELETE_PRODUCT_SAGA";
export const DELETE_PRODUCTS_SUCCESS = "DELETE_PRODUCTS_SUCCESS";

// ORDERS
export const GET_ORDERS_SAGA = "GET_ORDERS_SAGA";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAIL = "GET_ORDERS_FAIL";

// CART
export const GET_CART_SAGA = "GET_CART_SAGA";
export const GET_CART_SUCCESS = "GET_CART_SUCCESS";
export const GET_CART_FAIL = "GET_CART_FAIL";

export const ADD_CART_SAGA = "ADD_CART_SAGA";

export const REMOVE_FROM_CART_SAGA = "REMOVE_FROM_CART_SAGA";
export const REMOVE_FROM_CART_SUCCESS = "REMOVE_FROM_CART_SUCCESS";

export const PAYMENT_SAGA = "PAYMENT_SAGA";
export const PAYMENT_SUCCESS = "PAYMENT_SUCCESS";
